import { Organization } from "../../types"
import { Link } from "react-router-dom"
import DisconnectedNoTFN from "./DisconnectedNoTFN"
import { Heading } from "@planningcenter/doxy-web"
import ImageCarousel from "./ImageCarousel"
import { css } from "@emotion/react"

export default function Disconnected({
  organization,
}: {
  organization: Organization
}) {
  return (
    <>
      {!organization.text2give_phone_number ? (
        <DisconnectedNoTFN organization={organization} />
      ) : (
        <div
          className="d-f fd-c g-2 p-2"
          css={css`
            border: 1px solid var(--color-static-gray93);
            border-radius: 8px;
          `}
        >
          <p className="mb-3">
            To get started, text <strong>GIVE</strong> and the amount you want
            to give to <strong>{organization.text2give_phone_number}</strong>.{" "}
            <Link to="/giving/text-to-give/help" className="fw-500">
              Learn more
            </Link>
            , or{" "}
            <Link to={`sms:${organization.text2give_phone_number}`}>
              tap here to start a text to {organization.name}.
            </Link>
          </p>

          <div className="action-drawer p-2 d-f fd-c g-1">
            <Heading level={2} text="Example" />
            <ImageCarousel />
          </div>
        </div>
      )}
    </>
  )
}
